import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { icon } from '@fortawesome/fontawesome-svg-core/import.macro';

const errorIcon = <FontAwesomeIcon icon={icon({name: 'triangle-exclamation', style: 'solid'})} size="4x" color="hsl(var(--danger))" />;

const containerStyle = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  minHeight: '60vh',
  textAlign: 'center',
  padding: '2rem',
};

const descriptionStyle = {
  fontSize: '1.5rem',
  margin: '1rem 0 0.5rem 0',
  color: 'hsl(var(--text))',
};

const errorStyle = {
  background: 'hsl(var(--danger-soft))',
  color: 'hsl(var(--danger))',
  border: '1px solid hsl(var(--danger))',
  borderRadius: '8px',
  padding: '1rem',
  marginTop: '1rem',
  maxWidth: '500px',
  wordBreak: 'break-word',
};

const ErrorView = ({ error }) => {
  return (
    <div style={containerStyle}>
      {errorIcon}
      <div style={descriptionStyle}>Oops! Something went wrong.</div>
      <div style={{ color: 'hsl(var(--text-2))', marginBottom: '1rem' }}>
        An unexpected error has occurred. Please try again or contact support if the problem persists.
      </div>
      <div style={errorStyle}>
        {error ? error.toString() : "No error details available."}
      </div>
    </div>
  );
};

export default ErrorView;
